/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeiProductPromotionsData } from './hei-product-promotions.data';
import { IHeiProductPromotionsProps } from './hei-product-promotions.props.autogenerated';

export interface IHeiProductPromotionsViewProps extends IHeiProductPromotionsProps<IHeiProductPromotionsData> {}

/**
 *
 * HeiProductPromotions component
 * @extends {React.PureComponent<IHeiProductPromotionsProps<IHeiProductPromotionsData>>}
 */
class HeiProductPromotions extends React.PureComponent<IHeiProductPromotionsProps<IHeiProductPromotionsData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HeiProductPromotions;
